import React, { useState } from 'react'
import { ButtonText } from '../../../../StyledComponents'
import { Col, Input, Row } from 'reactstrap'
import maelano from '../../../../assets/icons/MaelanoIcon.png'
import PrimaryButton from '../../../../components/common/PrimaryButton/PrimaryButton'

const GiftCard = () => {

  const [showRedeemGiftCard, setShowRedeemGiftCard] = useState(false)
  const toggle = () => setShowRedeemGiftCard(!showRedeemGiftCard)

  const giftCardInstructions = [
    'Please enter your claim code in the field provided below.',
    'Type the alphanumeric code exactly as it appears on your product or gift card.',
    'Double-check the code for accuracy before proceeding.',
    `Once you've entered your claim code, click the "Add to Maelano Card" button.`,
    `This will instantly add the associated gift card value to your Maelano Card balance.`,
    `You'll receive a confirmation message confirming the successful redemption.`
  ]

  if (showRedeemGiftCard) {
    return (
      <div className='p-md-3'>
        <div onClick={toggle} className='cursor-pointer mb-3'><i className="fa fas fa-caret-left"></i> BACK</div>

        <div className='fs-5 fw-medium'>Gift Card</div>

        <div style={{ backgroundColor: "#F2F2F2", padding: '1rem', marginBlockStart: '1rem', borderRadius: '0.625rem' }}>

          <ul className='mb-0'>
            {giftCardInstructions.map(item => <li className='fs-5'>{item}</li>)}
          </ul>

        </div>

        <div className='fw-semibold fs-5 my-3'>Enter Claim Code</div>
        <Row className='align-items-center'>
          <Col xs='12' md='8'>
            <Input placeholder='Enter Code' />
          </Col>
          <Col xs='12' md='4' className='mt-2 mt-md-0'>
            <PrimaryButton name={'Add to Maelano Card'} />
          </Col>
        </Row>
      </div>
    )
  }


  return (
    <div>
      <ButtonText style={{ color: 'black', padding: '0.5rem', fontWeight: '500' }}>Gift Card</ButtonText>
      <Row className='w-100'>
        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
          <div>
            <div className='custom-card' style={{ width: 'auto', alignItems: 'unset' }} >
              <div>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }} >
                  <div className='custom-tab' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '200px' }}>
                    <div>
                      <img src={maelano} />
                    </div>
                  </div>
                  <div className='py-2'>
                    <button type='button' className='btn' style={{ background: 'transparent', color: 'black', border: '1px solid #d9d9d9', height: '41px', width: '167px' }} onClick={toggle}>Redeem Gift Card</button>
                  </div>
                </div>

              </div>


            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default GiftCard
